// @mui
import { SvgIcon } from "@mui/material";

function CalendarDayFillIcon(props) {
  return (
    <SvgIcon
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      sx={{
        fill: "transparent",
        "& path": {
          stroke: (theme) => theme.palette.common.white,
        },
      }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2725 16.739C16.2725 17.153 15.9365 17.489 15.5225 17.489C15.1085 17.489 14.7725 17.153 14.7725 16.739V12.389L14.7535 12.403C14.4225 12.654 13.9525 12.584 13.7045 12.254C13.4555 11.923 13.5225 11.453 13.8535 11.204L15.0725 10.289C15.2975 10.117 15.6045 10.091 15.8575 10.218C16.1125 10.344 16.2725 10.604 16.2725 10.888V16.739ZM9.9095 17.491C9.2275 17.491 8.5855 17.225 8.1015 16.743C7.8075 16.45 7.8075 15.975 8.0995 15.682C8.3915 15.387 8.8665 15.389 9.1605 15.68C9.3615 15.881 9.6265 15.991 9.9095 15.991C10.4915 15.991 10.9635 15.518 10.9635 14.936C10.9635 14.354 10.4915 13.882 9.9095 13.882C9.6205 13.882 9.3575 13.716 9.2325 13.455C9.1085 13.195 9.1435 12.885 9.3255 12.661L10.1495 11.638H8.5695C8.1555 11.638 7.8195 11.302 7.8195 10.888C7.8195 10.474 8.1555 10.138 8.5695 10.138H11.7175C12.0065 10.138 12.2695 10.304 12.3945 10.565C12.5185 10.825 12.4835 11.135 12.3015 11.359L11.1965 12.73C11.9545 13.174 12.4635 13.997 12.4635 14.936C12.4635 16.344 11.3175 17.491 9.9095 17.491ZM19.4525 5.327C18.7295 4.602 17.6985 4.193 16.4705 4.091V3.125C16.4705 2.711 16.1345 2.375 15.7205 2.375C15.3065 2.375 14.9705 2.711 14.9705 3.125V6.674C14.9055 6.692 14.8405 6.714 14.7695 6.714C14.3555 6.714 14.0195 6.378 14.0195 5.964V4.246C14.0195 4.13554 13.93 4.046 13.8195 4.046H9.1975V3.125C9.1975 2.711 8.8615 2.375 8.4475 2.375C8.0335 2.375 7.6975 2.711 7.6975 3.125V6.674C7.6325 6.692 7.5685 6.714 7.4965 6.714C7.0825 6.714 6.7465 6.378 6.7465 5.964V4.49991C6.7465 4.36988 6.62393 4.27436 6.49943 4.31189C4.59071 4.88717 3.4845 6.43796 3.4845 8.725V16.87C3.4845 19.848 5.2765 21.625 8.2775 21.625H15.8905C18.8915 21.625 20.6835 19.873 20.6835 16.938V8.726C20.6875 7.314 20.2625 6.139 19.4525 5.327Z"
        fill="#000000"
      />
    </SvgIcon>
  );
}

export default CalendarDayFillIcon;
